import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApplicationCurrency } from '../../models/currency/application-currency.interface';
import { HttpClient } from '@angular/common/http';
import { withCache } from '@ngneat/cashew';
import { Currency } from '@edassist/api';
import { constants } from '@edassist/common';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
	private readonly relativeUrl = 'currencies/';
	private readonly appllicationCurrencyRelativeUrl = 'applications/';
	constructor(private readonly http: HttpClient) {}

	getApplicationCurrency(
		applicationId: number
	): Observable<ApplicationCurrency> {
		return this.http
			.get<ApplicationCurrency>(
				`${this.appllicationCurrencyRelativeUrl}${applicationId.toString()}/currency`
			)
			.pipe(catchError(() => of(undefined)));
	}
	getCurrencies(): Observable<Array<Currency>> {
		return this.http
			.get<Array<Currency>>(`${this.relativeUrl}`, {
				context: withCache({
					version: constants.LOCAL_STORAGE.API_CACHE.VERSION_V1,
					key: 'getCurrencies'
				})
			})
			.pipe(catchError(() => of([])));
	}
	updateApplicationCurrencyConversionRate(
		applicationId: number,
		payload: ApplicationCurrency
	): Observable<ApplicationCurrency> {
		return this.http.put<ApplicationCurrency>(
			`${this.appllicationCurrencyRelativeUrl}${applicationId.toString()}/currency/conversion-rate`,
			payload
		);
	}
}
